import React from 'react'
import { Button, Col, Form, Modal, Row, Alert } from 'react-bootstrap'
import * as Yup from 'yup'
import type { FormikErrors, FormikTouched } from 'formik'
import type { AlertState } from '../common'

interface SubLayoutCopyFormValues {
  name: string
  draftNumber: number
}

interface SubLayoutCopyFormProps {
  values: SubLayoutCopyFormValues
  errors: FormikErrors<SubLayoutCopyFormValues>
  touched: FormikTouched<SubLayoutCopyFormValues>
  handleChange: React.ChangeEventHandler<HTMLElement>
  handleBlur: React.FocusEventHandler<HTMLElement>
  handleSubmit: React.SubmitEventHandler<HTMLFormElement>
  fetching: boolean
  title: string
  submitButtonText: string
  onClickCancel: () => void
  alert: AlertState | null
}

const _SubLayoutCopyForm = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  fetching,
  title,
  submitButtonText,
  onClickCancel,
  alert
}: SubLayoutCopyFormProps) => (
  <>
    <Modal.Header>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    {alert?.show && alert?.alertBody && (
      <Alert className='copy-sub-layout-error-alert' variant='danger'>
        {alert.alertBody}
      </Alert>
    )}
    <Form noValidate onSubmit={handleSubmit}>
      <Modal.Body>
        <p>以下の小組を複製します。よろしいですか？</p>
        <p>コピー元小組名称：{values.name}</p>
        <Row>
          <Form.Group as={Col}>
            <Form.Label column>コピー後小組ドラフト数</Form.Label>
            <Form.Control
              id='draftNumberInput'
              name='draftNumber'
              type='number'
              value={values.draftNumber}
              onChange={handleChange}
              onBlur={handleBlur}
              isInvalid={!!(touched.draftNumber && errors.draftNumber)}
            />
            <Form.Control.Feedback type='invalid'>{errors.draftNumber}</Form.Control.Feedback>
          </Form.Group>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClickCancel}>
          キャンセル
        </Button>
        <Button type='submit' disabled={fetching}>
          {submitButtonText}{' '}
        </Button>
      </Modal.Footer>
    </Form>
  </>
)

export const SubLayoutCopyForm = Object.assign(_SubLayoutCopyForm, {
  schema: Yup.object().shape({
    name: Yup.string().required(),
    draftNumber: Yup.number().required().min(1)
  })
})
